import {Bell, Map, Route, Smartphone} from "lucide-react";
import {useRideLanguage} from "../ride-language";

// Same store destinations used by the native app.
export const CHERRI_APP_STORE = "https://apps.apple.com/app/cherri/id1588721133";
export const CHERRI_PLAY_STORE = "https://play.google.com/store/apps/details?id=com.cherri";

export function AppDownloadLinks() {
  const {t} = useRideLanguage();
  return <div className="ride-store-links">
    <a className="ride-button" href={CHERRI_APP_STORE} target="_blank" rel="noopener noreferrer"><Smartphone size={17}/>{t("App Store")}</a>
    <a className="ride-button ride-button-secondary" href={CHERRI_PLAY_STORE} target="_blank" rel="noopener noreferrer"><Smartphone size={17}/>{t("Google Play")}</a>
  </div>;
}

export function AppDownload({features = false}: {features?: boolean}) {
  const {t} = useRideLanguage();
  return <section className="ride-app-download" aria-label={t("Get the Cherri app")}>
    <h2>{t("Get the Cherri app")}</h2>
    {features ? <ul className="ride-app-features">
      <li><Route size={18}/>{t("Choose your route")}</li>
      <li><Map size={18}/>{t("Map view")}</li>
      <li><Bell size={18}/>{t("Live join notifications")}</li>
    </ul> : <p className="ride-help">{t("Use the app for live notifications about join requests and ride updates. Enable notifications after signing in.")}</p>}
    <AppDownloadLinks/>
  </section>;
}
